// removed by extract-text-webpack-plugin
module.exports = {"default":"_1s0Hbq5DqGbFiLfdMg9A1-","avatar":"_4dqkYruAPsslJ1Eul3kHr","img":"_3dcSdcnkXjMr4ZCjBzlEh6","small":"_1Boo3cJf1Nv0voTPRrX07c"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/avatar/avatar.scss
// module id = 405
// module chunks = 0